import ActionTypes from '../Actions/ActionTypes';

let initialState = {
  Theme: {
    Primary: '#EF62BD',
    LightPrimary: '#F7B0DE',
    DPink: '#B63789', // only color for dark variant
    PrimaryBorder: 'rgba(239, 98, 189, 0.5)',
    SecondaryBorder: 'rgba(96, 112, 143, 0.5)',
    // Secondary: '#222B45',
    Secondary: '#000',
    Optional: '#A9A9A9',
    LGrey: '#F7F7FC',
    White: '#fff',
    WhiteRGBA: 'rgba(255, 255, 255, 0.8)',
    Black: '#000',
    Green: '#1AA603',
    Grey: '#60708F',
    // Grey: '#C6C6C6',
    Red: '#FF0000',
    LightRed: '#FF5555',
    FontBItalic: 'Poppins-BoldItalic',
    FontItalic: 'Poppins-Italic',
    FontFamily: 'Poppins-Regular',
    FontBold: 'Poppins-Bold',
    FontSBold: 'Poppins-SemiBold',
    FontMedium: 'Poppins-Medium',
    FontRegular: 'LeckerliOne-Regular',
    Heading: '#1E2742',
    grey: '#DDDDDD',
    LightGrey: '#999999',
    Border: '#E4E4E4',
    textGrey: 'rgba(30, 39, 66, 0.5)',
    bar: '#EAE9F0',
    Yellow: '#ffc40c',
    LightGreen: '#1EA624',
    PinkGradient: 'rgba(255,255,255,0.4)',
    DarkBlue: '#201D67',
    Transparent: 'transparent',
    Shadow: 'rgba(0,0,0,0.0.5)',
    HeadingBlack: '#171328',
    PrimaryGrey: '#9E9E9E',
    BorderGrey: '#EBEBEB',
    LinkGrey: '#979797',
    hrLineGrey: '#8D8D8D',
    tableGrey: '#E0E0E0',
    BGGrey: '#BDBDBD',
    Egrey: '#c4c4c4',
    CodeColor: '#595959',
    Indigo: '#3F00FF',
    LBlue: '#01F9C6',
    DGreen: '#2E8B57',
    Maroon: '#800000',
    OffWhite: '#FAFAFB',
    dotGreen: '#34C658',
  },
};

const ThemeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_THEME:
      state = {...state, Theme: {...state.Theme, ...action.payload}};
      break;

    default:
      break;
  }
  return state;
};

export const shadow = {
  elevation: 7,
  shadowColor: '#000',
  shadowOffset: {width: 0, height: 2},
  shadowOpacity: 0.8,
  shadowRadius: 2,
};

export default ThemeReducer;
